const ORDER_STATUS_STYLES: Record<
  string,
  { label: string; className: string }
> = {
  placed: {
    label: "Placed",
    className: "bg-gray-100 text-gray-700",
  },
  confirmed: {
    label: "Confirmed",
    className: "bg-blue-100 text-blue-700",
  },
  processing: {
    label: "Processing",
    className: "bg-indigo-100 text-indigo-700",
  },
  shipped: {
    label: "Shipped",
    className: "bg-purple-100 text-purple-700",
  },
  delivered: {
    label: "Delivered",
    className: "bg-green-100 text-green-700",
  },
  cancelled: {
    label: "Cancelled",
    className: "bg-red-100 text-red-700",
  },
};

const WASH_STATUS_STYLES: Record<string, { label: string; className: string }> =
  {
    booked: {
      label: "Booked",
      className: "bg-gray-100 text-gray-700",
    },
    confirmed: {
      label: "Confirmed",
      className: "bg-blue-100 text-blue-700",
    },
    assigned: {
      label: "Assigned",
      className: "bg-cyan-100 text-cyan-700",
    },
    on_the_way: {
      label: "On the way",
      className: "bg-yellow-100 text-yellow-700",
    },
    in_progress: {
      label: "In progress",
      className: "bg-indigo-100 text-indigo-700",
    },
    completed: {
      label: "Completed",
      className: "bg-green-100 text-green-700",
    },
    cancelled: {
      label: "Cancelled",
      className: "bg-red-100 text-red-700",
    },
  };

export { ORDER_STATUS_STYLES, WASH_STATUS_STYLES };
